export const en = {
  "meta.title": "ArtLove365 - Hand-painted oil paintings",
  "meta.description": "Museum-quality, hand-painted oil reproductions of the world's greatest masterpieces, and custom oil portraits painted from your photos.",
  "nav.gallery": "Gallery",
  "nav.artists": "Artists",
  "nav.custom": "Paint my photo",
  "nav.track": "Track order",
  "home.eyebrow": "Hand-painted in oil, by real artists",
  "home.title": "Masterpieces for your walls. Your memories, painted like masterpieces.",
  "home.subtitle": "Choose from the most beloved paintings in history, or upload your own photo. Our artists paint it on canvas by hand and ship it to your door.",
  "home.ctaGallery": "Browse the gallery",
  "home.ctaCustom": "Upload a photo",
  "home.stepsTitle": "How it works",
  "home.step1Title": "Choose or upload",
  "home.step1Body": "Pick a masterpiece, or upload a photo of your family, pet or favourite place.",
  "home.step2Title": "We paint it",
  "home.step2Body": "A professional oil painter works on real canvas. For custom orders you approve a sketch first.",
  "home.step3Title": "Delivered to you",
  "home.step3Body": "After drying, your painting is carefully packed and shipped worldwide with tracking.",
  "home.featured": "Featured masterpieces",
  "gallery.title": "Gallery of masterpieces",
  "gallery.subtitle": "Every painting is reproduced by hand in oil on canvas - no prints.",
  "gallery.filterAll": "All artists",
  "gallery.empty": "No paintings found.",
  "artists.title": "The masters",
  "artists.works": "View works",
  "artwork.by": "by",
  "artwork.order": "Order this painting",
  "artwork.notFound": "This painting was not found.",
  "order.size": "Canvas size",
  "order.frame": "Finish",
  "frame.rolled": "Rolled canvas (in a tube)",
  "frame.stretched": "Stretched, ready to hang",
  "frame.framed": "Stretched + wooden frame",
  "order.subjects": "People or pets in the photo",
  "order.price.base": "Painting",
  "order.price.frame": "Finish",
  "order.price.custom": "Custom portrait",
  "order.price.shipping": "Shipping",
  "order.price.free": "Free",
  "order.price.total": "Total",
  "order.contact": "Shipping details",
  "order.name": "Full name",
  "order.email": "Email",
  "order.phone": "Phone",
  "order.address": "Street address",
  "order.city": "City",
  "order.postalCode": "Postal code",
  "order.country": "Country",
  "order.notes": "Notes for the artist (optional)",
  "order.submit": "Continue to payment",
  "order.submitting": "Placing your order…",
  "order.error": "Something went wrong. Please check the form and try again.",
  "order.leadTime": "Painting takes 2-3 weeks plus 1 week of drying before shipping.",
  "custom.title": "Turn your photo into an oil painting",
  "custom.subtitle": "Upload a clear, well-lit photo. Our artists will paint it by hand - and you approve the sketch before we start.",
  "custom.upload": "Choose a photo",
  "custom.uploadHint": "JPG, PNG or WebP, up to 20 MB. Higher resolution gives a better painting.",
  "custom.uploading": "Uploading…",
  "custom.uploaded": "Photo uploaded",
  "custom.replace": "Use a different photo",
  "custom.style": "Painting style",
  "custom.style.classic": "Classic realism",
  "custom.style.impressionist": "Impressionist (like Monet)",
  "custom.style.vangogh": "Expressive brushwork (like Van Gogh)",
  "custom.style.modern": "Modern, soft palette",
  "custom.needPhoto": "Please upload a photo first.",
  "track.title": "Track your order",
  "track.code": "Order code",
  "track.submit": "Find order",
  "track.notFound": "We could not find an order with that code and email.",
  "track.placed": "Placed on",
  "success.title": "Thank you! Your order has been placed.",
  "success.body": "We have emailed a confirmation. Keep your order code to follow its progress.",
  "status.awaiting_payment": "Awaiting payment",
  "status.paid": "Paid",
  "status.sketching": "Sketching",
  "status.painting": "Painting",
  "status.drying": "Drying",
  "status.shipped": "Shipped",
  "status.delivered": "Delivered",
  "status.cancelled": "Cancelled",
  "common.loading": "Loading…",
  "common.back": "Back",
  "footer.tagline": "Hand-painted oil paintings, shipped worldwide.",
  "footer.follow": "Follow us",
  "footer.docs": "Help & documentation",
  "gallery.search": "Search paintings or artists…",
  "sketch.title": "Your sketch is ready",
  "sketch.body": "Please check the composition. We start painting only after you approve it.",
  "sketch.approve": "Approve sketch",
  "sketch.change": "Request changes",
  "sketch.feedback": "What should we change?",
  "sketch.send": "Send feedback",
  "sketch.approved": "Sketch approved - painting has started.",
  "sketch.changesSent": "Thank you! The artist will send you a revised sketch.",
  "checkout.title": "Payment",
  "checkout.demoBanner": "Demo mode - online payment is not live yet. No money will be charged and no card details are collected.",
  "checkout.summary": "Order summary",
  "checkout.method": "Payment method",
  "checkout.method.card": "Credit / debit card",
  "checkout.method.paypal": "PayPal",
  "checkout.method.wallet": "Apple Pay / Google Pay",
  "checkout.method.bank": "Bank transfer",
  "checkout.cardNumber": "Card number",
  "checkout.expiry": "Expiry (MM/YY)",
  "checkout.cvc": "CVC",
  "checkout.cardName": "Name on card",
  "checkout.paypalNote": "You will be redirected to PayPal to approve the payment.",
  "checkout.walletNote": "Confirm with Face ID, Touch ID or your phone.",
  "checkout.bankNote": "We will email you our bank details. Your order starts once the transfer arrives (1-3 business days).",
  "checkout.pay": "Pay {amount}",
  "checkout.processing": "Processing payment…",
  "checkout.secure": "Payments are encrypted and handled by our payment partner. We never store card numbers.",
  "checkout.demoDoneTitle": "Payment simulated",
  "checkout.demoDoneBody": "This was a demo - nothing was charged. Your order is saved and stays “Awaiting payment”; our team will contact you to complete payment.",
  "checkout.failTitle": "Payment declined",
  "checkout.failBody": "Your bank declined the payment. Please check the details or try another method.",
  "checkout.retry": "Try again",
  "checkout.viewOrder": "View my order",
  "track.payNow": "Pay now",
  "browse.title": "Browse",
  "browse.movements": "Art movements",
  "browse.museums": "Museums",
  "browse.subjects": "Subjects",
  "browse.genres": "Genres",
  "artwork.year": "Year",
  "artwork.size": "Original size",
  "artwork.museum": "Museum",
  "artwork.movement": "Movement",
  "artwork.genre": "Genre",
  "artwork.subjects": "Subjects",
  "artwork.moreBy": "More by",
  "pager.prev": "Previous",
  "pager.next": "Next",
  "count.paintings": "{n} paintings",
  "fav.add": "Add to favorites",
  "fav.remove": "Remove from favorites",
  "fav.title": "My favorites",
  "fav.empty": "No favorites yet. Tap the heart on any painting you love and it will wait for you here.",
  "fav.emptyCta": "Explore the gallery",
  "fav.syncHint": "Sign in with Google to keep your favorites on every device.",
  "fav.saved": "Saved to your favorites",
  "fav.nav": "Favorites",
  "account.signIn": "Sign in",
  "account.signOut": "Sign out",
  "account.signedInAs": "Signed in as",
  "account.signInTitle": "Sign in to ArtLove365",
  "viewer.open": "View full screen",
  "viewer.close": "Close",
  "viewer.hint": "Scroll or pinch to zoom · drag to explore · double-click to reset",
  "share.button": "Share",
  "share.copied": "Link copied",
  "artwork.story": "About this painting",
  "artwork.details": "Details",
  "artwork.aboutArtist": "About the artist",
  "artwork.readArtist": "Discover {name}'s life story",
  "artwork.relatedArtists": "Paintings by related artists",
  "rel.influenced_by": "Inspired {artist}",
  "rel.influenced": "Inspired by {artist}",
  "rel.student_of": "Teacher of {artist}",
  "rel.student": "Student of {artist}",
  "rel.movement": "Also {movement}",
  "story.didYouKnow": "Did you know?",
  "story.sources": "Sources",
  "story.aiNote": "Written with the help of AI from the sources below. Spotted an error? Please let us know.",
  "artist.relatedArtists": "Related artists",
  "artist.worksBy": "Paintings by {name}",
  "nav.how": "How it works",
  "home.ctaArtists": "Meet the artists",
  "home.discover": "Get to know us",
  "home.howCardTitle": "How we work",
  "home.howCardBody": "Real painters, real canvas, oil paint and patience. See how a masterpiece is recreated by hand.",
  "home.customCardTitle": "Your photo, painted in oil",
  "home.customCardBody": "Family, couples, pets, the house you grew up in - see how we turn a photo into a painting.",
  "home.featuredArtists": "Meet the masters",
  "home.browseMovements": "Explore by movement",
  "common.readMore": "Read more",
  "how.title": "How we work",
  "how.intro": "Every ArtLove365 painting is made by hand, with oil paint on real canvas, by professional painters. No printing, no shortcuts. Here is what happens between a masterpiece and your wall.",
  "how.s1t": "It starts with a painting you love",
  "how.s1b": "Explore thousands of masterpieces, read their stories, and keep the ones that move you in your favorites.",
  "how.s2t": "A painter studies the original",
  "how.s2b": "Before the first stroke, the painter studies composition, colour and the way the master applied paint - the order of the layers matters as much as the colours.",
  "how.s3t": "Painted by hand, layer by layer",
  "how.s3b": "Oil is built up slowly: an underpainting, the main masses, then details and glazes. A medium-sized canvas takes two to three weeks of work.",
  "how.s4t": "Checked, then left to dry",
  "how.s4b": "A senior painter compares the canvas with the original. Oil paint then needs about a week to dry before it can travel safely.",
  "how.s5t": "Carefully packed, sent worldwide",
  "how.s5b": "Paintings travel rolled in a rigid tube or stretched in a reinforced box, with tracking all the way to your door.",
  "how.materialsTitle": "Materials",
  "how.materialsBody": "Artist-grade oil paints, primed cotton or linen canvas, and varnish to protect the surface for decades.",
  "how.customTitle": "Painting from your own photo",
  "how.customBody": "For portraits and personal scenes we add one step: you approve a sketch of the composition before we start painting.",
  "custom.pageTitle": "Custom oil paintings from your photos",
  "custom.pageIntro": "A photo keeps a moment. A painting makes it last. Our painters turn your photos into hand-painted oil portraits and scenes - in the style you choose.",
  "custom.howTitle": "How it works",
  "custom.step1t": "You share a photo",
  "custom.step1b": "One clear photo is enough; we can also combine several into one scene.",
  "custom.step2t": "You approve a sketch",
  "custom.step2b": "Our painter prepares the composition. Nothing is painted until you are happy with it.",
  "custom.step3t": "We paint it by hand",
  "custom.step3b": "Oil on canvas, layer by layer, in the style you chose.",
  "custom.step4t": "It comes home",
  "custom.step4b": "After drying and a final check, your painting is packed and shipped with tracking.",
  "custom.stylesTitle": "Choose a style",
  "custom.styleDesc.classic": "Faithful likeness, soft light and fine detail, in the tradition of the old masters.",
  "custom.styleDesc.impressionist": "Light and atmosphere in loose, vibrant touches - like a summer afternoon by Monet.",
  "custom.styleDesc.vangogh": "Thick, swirling brushwork and bold colour, inspired by Van Gogh.",
  "custom.styleDesc.modern": "Clean shapes and a soft, contemporary palette that fits modern interiors.",
  "custom.occasionsTitle": "Loved for",
  "custom.occ.family": "Family portraits",
  "custom.occ.couples": "Couples and weddings",
  "custom.occ.pets": "Pets",
  "custom.occ.children": "Children",
  "custom.occ.memorial": "In loving memory",
  "custom.occ.home": "Homes and places",
  "custom.tipsTitle": "Choosing a good photo",
  "custom.tip1": "Sharp focus, especially on the eyes.",
  "custom.tip2": "Soft daylight; avoid harsh flash and strong filters.",
  "custom.tip3": "Faces large enough to see expressions clearly.",
  "custom.tip4": "Several photos? We can combine people or pets into one painting.",
  "custom.explore": "Explore styles in the gallery",
  "showcase.title": "Commissions we have painted",
  "showcase.subtitle": "Real paintings made for our customers, shown with their permission.",
  "showcase.all": "All",
  "custom.occ.nail": "Nail salon décor",
  "custom.occ.other": "Other",
  "home.newTitle": "Newly told stories",
  "home.newWhy": "The latest paintings to get their full story - something new every day.",
  "home.gemsTitle": "Hidden gems",
  "home.gemsWhy": "Less famous, just as moving. Paintings most people walk past - and shouldn't.",
  "taxon.faqTitle": "Curious about {name}?",
  "notFound.title": "Page not found",
} as const;

export type MessageKey = keyof typeof en;
export type Messages = Record<MessageKey, string>;
